import { render, staticRenderFns } from "./CollectionProducts.vue?vue&type=template&id=329426ab&name=collection-products&"
import script from "./CollectionProducts.vue?vue&type=script&lang=js&"
export * from "./CollectionProducts.vue?vue&type=script&lang=js&"
import style0 from "./CollectionProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports